import Vue from 'vue';
import store from './../../store';
import orderTransformer from './../../transformers/order';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const orders = orderTransformer.fetchCollection(data.data);

  let pagination = {};
  if (data.pagination) {
    pagination = paginationTransformer.fetch(data.pagination);
  }

  store.dispatch('fetchPaginatedOrders', { orders, pagination });
  resolve();
};

const failed = (error, reject) => reject(error);

export default (params = {}) => (
  new Promise((resolve, reject) => (
    Vue.$http.get(helpers.buildUrl('/orders', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    })
  ))
);



// WEBPACK FOOTER //
// ./src/app/services/order/items.js